import React, { useEffect } from 'react';
import { Flex } from '@spothero/ui';
import FiltersModal from 'common/search-filters-controls/filters-modal';
import { useDispatch, useSelector } from 'react-redux';
import { getAmenities, getRatings } from 'store/filters/filters-selectors';
import { getSpotsV2 } from 'store/spots/spots-selectors';
import { FilterCheckboxBase } from './filter-bases';
import { CountOrIcon } from './count-or-icon/CountOrIcon';
import { useFilterModal } from './utils/modalToggle';
import { FiltersHourly } from './modules/transient/FiltersHourly';
import { FiltersMonthly } from './modules/monthly/FiltersMonthly';
import { getFiltersSession } from 'store/filters/filters-actions';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
import { FiltersAirport } from './modules/airport/FiltersAirport';
export const FilterSelection = () => {
    const { showModal, onModalToggle, onFilterChange, onClearFilters, } = useFilterModal();
    const dispatch = useDispatch();
    const amenities = useSelector((state) => getAmenities(state));
    const ratings = useSelector((state) => getRatings(state));
    const numSpots = useSelector((state) => getSpotsV2(state).length);
    const numActiveFilters = useSelector((state) => state.filters.numActive);
    const activeAmenities = useSelector((state) => state.filters.activeAmenities);
    const activeRatingTypes = useSelector((state) => state.filters.activeRatingTypes);
    const isMonthly = useSelector((state) => state.searchRequest.monthly);
    const isAirport = useSelector((state) => state.searchRequest.airport);
    const isMobile = useMobileBreakPoint();
    // Make sure session storage is used when this component is mounted
    useEffect(() => {
        dispatch(getFiltersSession());
    }, [dispatch]);
    return (<Flex flexGrow={1} gap={{ base: 2, tablet: 4 }} alignItems="center" paddingY="4" width="100%" overflowX={{ base: 'auto', desktop: 'visible' }} paddingX={{ base: '4', tablet: '8' }} backgroundColor={{ base: 'inherit', tablet: 'white' }} borderTopWidth={{ tablet: '1px', base: '0px' }} borderTopStyle="solid" borderTopColor="gray.200" data-testid="FilterSelection-container">
            <FilterCheckboxBase onClick={onModalToggle} isActive={Boolean(showModal || numActiveFilters)} testid="QuickFilters-filter-condensed" order={isMobile ? 1 : undefined}>
                <CountOrIcon />
                Filters
            </FilterCheckboxBase>
            {isAirport ? (<FiltersAirport />) : isMonthly ? (<FiltersMonthly />) : (<FiltersHourly />)}
            <FiltersModal numSpots={numSpots} amenities={amenities} activeAmenities={activeAmenities} numActiveFilters={numActiveFilters} onChange={onFilterChange} onClear={onClearFilters} onHidden={onModalToggle} isOpen={showModal} allRatings={ratings} activeRatingTypes={activeRatingTypes}/>
        </Flex>);
};
